import {DataARTransactionItemModel} from '../../../models/accountsReceivable/data-ar-transaction-item.model';
import {DataARLedgerModel} from '../../../models/accountsReceivable/data-ar-ledger.model';

export class CreateClaimsModel {
  ClaimDate: Date;
  PatientInsuranceID: string;
  PatientID: string;
  transactionItems: DataARTransactionItemModel[];
  enumClaimTypeID: string;
  ledgerItems: DataARLedgerModel[];
  ProviderDoctorID: string;
  DoctorARAccountID: string;
  DoctorARLocID: string;
  LOCID: number;
}
